import { all, fork } from "redux-saga/effects";
import dashboardSaga from "./dashboardSaga";
import loginSaga from "./loginSaga";
import userManagement from "./userManagement";
import tenantManagement from "./tenantManagement";
import rbacManagement from "./rbacManagement";
import resourceManager from "./resourceManager";
import machineCatalog from "./machineCatalog";
import machineCatalogue from "./machineCatalogue";
import myLabs from "./myLabs";
import userMachineCatalog from "./userMachineCatalog";
import notificationManagement from "./notificationManagement";
import common from "./common";
import requestManager from "./requestManager";
import actionLog from "./actionLog";
import headerNotification from "./headerNotification";
import notifications from "./notifications";
import notificationSettings from "./notificationSettings";
import usage from "./usage";
import workspaceManager from "./workspaceManager";
import userWorkspaceManager from "./userWorkspaceManager";
import help from "./help";
import directLoginSaga from "./directLoginSaga";
import vmInsight from "./vmInsightSaga";
import b2c from "./b2c";
import invoicingSaga from "./invoicingSaga";
import resellerLicenseSaga from "./resellerLicense";
import customReportsSaga from "./customReportsSaga";
import publicResourceManager from "./publicResourceManagerSaga";

export default function* rootSaga() {
  yield all([
    fork(dashboardSaga),
    fork(loginSaga),
    fork(userManagement),
    fork(tenantManagement),
    fork(rbacManagement),
    fork(resourceManager),
    fork(machineCatalog),
    fork(machineCatalogue),
    fork(myLabs),
    fork(notificationManagement),
    fork(userMachineCatalog),
    fork(common),
    fork(requestManager),
    fork(actionLog),
    fork(headerNotification),
    fork(notifications),
    fork(notificationSettings),
    fork(usage),
    fork(workspaceManager),
    fork(userWorkspaceManager),
    fork(help),
    fork(directLoginSaga),
    fork(vmInsight),
    fork(b2c),
    fork(invoicingSaga),
    fork(resellerLicenseSaga),
    fork(customReportsSaga),
    fork(publicResourceManager)
  ]);
}
